/* FluidContainer.ts generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
const _7 = "@media screen and (min-width:1920px){._pghyidpf{margin-top:0}._7ieg1wug{margin-right:auto}._1q2jidpf{margin-bottom:0}._1jlr1wug{margin-left:auto}._1vwx1oad{max-width:96pc}}";
const _6 = "@media (min-width:110rem){._djbmidpf{margin-top:0}._17dqd36x{margin-right:2in}._1ohsidpf{margin-bottom:0}._106sd36x{margin-left:2in}}";
const _5 = "@media (min-width:90rem){._1b2sidpf{margin-top:0}._2dx0qkoa{margin-right:9pc}._nkieidpf{margin-bottom:0}._1yoqqkoa{margin-left:9pc}}";
const _4 = "@media (min-width:64rem){._ue5g1408{margin:0 var(--ds-space-800,4pc)}}";
const _3 = "@media (min-width:48rem){._33c5zdiv{margin:0 var(--ds-space-500,40px)}}";
const _2 = "@media (min-width:30rem){._1letfkly{margin:0 var(--ds-space-400,2pc)}}";
const _ = "._18s81e2i{margin:0 var(--ds-space-300,24px)}";
export const FluidContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18s81e2i _1letfkly _33c5zdiv _ue5g1408 _1b2sidpf _2dx0qkoa _nkieidpf _1yoqqkoa _djbmidpf _17dqd36x _1ohsidpf _106sd36x _pghyidpf _7ieg1wug _1q2jidpf _1jlr1wug _1vwx1oad", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  FluidContainer.displayName = 'FluidContainer';
}